import type { VideoEffects } from './types';
import { sectionsWithinClip } from './sectionTimeline';

/** Same gate shape as layers and transitions: free to add and preview,
 *  exporting a clip whose timeline effect sections actually render requires
 *  PRO. Sections render regardless of the Effects switch (it gates only the
 *  base look); nothing renders at intensity 0 or from a section starting at or
 *  after the clip end — the backend/worker `hasActiveVideoEffects` agrees on
 *  the first two. Without a finite positive `clipDuration` the time filter is
 *  skipped. */
export function canExportWithEffectSections({ isPro, effects, clipDuration }: {
  isPro: boolean; effects: VideoEffects; clipDuration?: number;
}): boolean {
  if (isPro) return true;
  return !sectionsWithinClip(effects.sections ?? [], clipDuration).some((s) => s.intensity > 0);
}
